/* ============================================
   MEDALLION CO. — SHOPIFY THEME JS
   theme.js — Drop into assets/
   ============================================ */

(function () {
  'use strict';

  // ---- SCROLL REVEAL ----
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(el => revealObserver.observe(el));
  }

  // ---- STICKY HEADER ----
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  // ---- STICKY ATC ----
  const stickyAtc = document.getElementById('sticky-atc');
  const addBtn = document.getElementById('product-add-btn');
  if (stickyAtc && addBtn) {
    const atcObserver = new IntersectionObserver(([entry]) => {
      stickyAtc.classList.toggle('visible', !entry.isIntersecting);
    });
    atcObserver.observe(addBtn);

    const stickyBtn = document.getElementById('sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => addBtn.click());
    }
  }

  // ---- QUANTITY PICKERS ----
  document.querySelectorAll('.qty-picker').forEach(picker => {
    const input = picker.querySelector('.qty-picker__input');
    if (!input) return;

    picker.querySelectorAll('.qty-picker__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const delta = btn.dataset.action === 'increase' ? 1 : -1;
        const key = btn.dataset.key;
        const newVal = Math.max(0, parseInt(input.value, 10) + delta);
        input.value = newVal;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (key) updateCartItem(key, newVal);
      });
    });

    // Cart page line-item change
    if (input.dataset.key) {
      input.addEventListener('change', () => {
        updateCartItem(input.dataset.key, parseInt(input.value, 10));
      });
    }
  });

  // ---- PRODUCT GALLERY THUMBS ----
  const mainImg = document.getElementById('product-gallery-main-img');
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('product-gallery__thumb--active'));
      thumb.classList.add('product-gallery__thumb--active');
      if (mainImg && thumb.dataset.imageUrl) {
        mainImg.src = thumb.dataset.imageUrl;
      }
    });
  });

  // ---- PRODUCT TABS ----
  document.querySelectorAll('.product-tabs__tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      document.querySelectorAll('.product-tabs__tab').forEach(t => t.classList.remove('product-tabs__tab--active'));
      document.querySelectorAll('.product-tabs__panel').forEach(p => p.classList.add('product-tabs__panel--hidden'));
      tab.classList.add('product-tabs__tab--active');
      const panel = document.querySelector(`.product-tabs__panel[data-panel="${target}"]`);
      if (panel) panel.classList.remove('product-tabs__panel--hidden');
    });
  });

  // ---- QUICK ADD (Collection) ----
  document.querySelectorAll('.product-card__quick-add-btn').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;
      btn.textContent = 'Adding...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (res.ok) {
          btn.textContent = '✓ Added!';
          updateCartCount();
          showToast('Item added to cart!');
          setTimeout(() => { btn.textContent = 'Quick Add to Cart'; }, 2000);
        } else {
          btn.textContent = 'Unavailable';
        }
      } catch {
        btn.textContent = 'Error — try again';
      }
    });
  });

  // ---- ADD TO CART (Product page) ----
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      const submitBtn = productForm.querySelector('[name="add"]');
      if (!submitBtn) return;
      // Let Shopify handle buy-now button normally
      if (e.submitter && e.submitter.name === 'goto_weburl') return;

      e.preventDefault();
      const formData = new FormData(productForm);
      submitBtn.disabled = true;
      const originalText = submitBtn.querySelector('span')?.textContent || 'ADD TO CART';
      if (submitBtn.querySelector('span')) submitBtn.querySelector('span').textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(formData.get('id'), 10),
            quantity: parseInt(formData.get('quantity') || 1, 10),
          }),
        });
        if (res.ok) {
          if (submitBtn.querySelector('span')) submitBtn.querySelector('span').textContent = '✓ Added!';
          updateCartCount();
          showToast('Added to cart!');
          setTimeout(() => {
            if (submitBtn.querySelector('span')) submitBtn.querySelector('span').textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        }
      } catch {
        submitBtn.disabled = false;
        if (submitBtn.querySelector('span')) submitBtn.querySelector('span').textContent = originalText;
      }
    });
  }

  // ---- VARIANT SELECTION ----
  document.querySelectorAll('.option-swatch__input').forEach(input => {
    input.addEventListener('change', async () => {
      document.querySelectorAll('.option-swatch').forEach(s => s.classList.remove('option-swatch--selected'));
      input.closest('.option-swatch').classList.add('option-swatch--selected');
      // Find matching variant and update hidden id + price
      await updateSelectedVariant();
    });
  });

  async function updateSelectedVariant() {
    const productHandle = document.querySelector('[data-product-handle]')?.dataset.productHandle;
    if (!productHandle) return;

    const selectedOptions = [];
    document.querySelectorAll('.product-option').forEach(optionGroup => {
      const selected = optionGroup.querySelector('.option-swatch__input:checked');
      if (selected) selectedOptions.push(selected.value);
    });

    try {
      const res = await fetch(`/products/${productHandle}.js`);
      const product = await res.json();
      const variant = product.variants.find(v => {
        return selectedOptions.every((opt, i) => v.options[i] === opt);
      });
      if (variant) {
        document.getElementById('product-variant-id').value = variant.id;
        // Update price display
        const priceEl = document.querySelector('.product-price--current');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
      }
    } catch (err) {
      console.warn('Variant update failed', err);
    }
  }

  // ---- CART UPDATE ----
  async function updateCartItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (res.ok) {
        const cart = await res.json();
        updateCartCount(cart.item_count);
        // Reload page to reflect updated totals
        if (quantity === 0) location.reload();
        else updateCartSummary(cart);
      }
    } catch (err) {
      console.warn('Cart update error', err);
    }
  }

  function updateCartSummary(cart) {
    const totalEl = document.querySelector('.cart-summary__total span:last-child');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  // ---- CART COUNT ----
  async function updateCartCount(count) {
    if (count === undefined) {
      try {
        const res = await fetch('/cart.js');
        const data = await res.json();
        count = data.item_count;
      } catch { return; }
    }
    const countEl = document.querySelector('.header-cart-btn__count');
    if (countEl) {
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    } else if (count > 0) {
      const cartBtn = document.querySelector('.header-cart-btn');
      if (cartBtn) {
        const badge = document.createElement('span');
        badge.className = 'header-cart-btn__count';
        badge.textContent = count;
        cartBtn.appendChild(badge);
      }
    }
  }

  // ---- TOAST ----
  function showToast(message) {
    const toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.textContent = '✓ ' + message;
    toast.classList.add('visible');
    setTimeout(() => toast.classList.remove('visible'), 2500);
  }

  // ---- MONEY FORMAT ----
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const format = window.theme?.moneyFormat || '${{amount}}';
    return format.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents/100));
  }

  // ---- CART UPSELL (Recommendations API) ----
  const upsellContainer = document.getElementById('cart-upsell-items');
  if (upsellContainer) {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      if (!cart.items.length) return;
      const productId = cart.items[0].product_id;
      return fetch(`/recommendations/products.json?product_id=${productId}&limit=3&intent=related`);
    }).then(r => r && r.json()).then(data => {
      if (!data?.products?.length) return;
      upsellContainer.innerHTML = data.products.map(p => `
        <div class="cart-upsell-item">
          <img src="${p.featured_image}" alt="${p.title}" width="40" height="40" loading="lazy">
          <div>
            <div class="cart-upsell-item__name">${p.title}</div>
            <div class="cart-upsell-item__price">${formatMoney(p.price)}</div>
          </div>
          <button
            class="btn btn--outline btn--sm"
            data-variant-id="${p.variants[0].id}"
            onclick="fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:${p.variants[0].id},quantity:1})}).then(()=>{location.reload()})"
          >+ Add</button>
        </div>
      `).join('');
    }).catch(() => {});
  }

})();
